module.exports = __webpack_public_path__ + "img/loader.6075999d.svg";